import React, { useCallback } from 'react'
import { useResponsiveWrapperContext } from '@usap/uicomponents'

import { formatBrand } from '../../../../../../transformers/BrandText'
import generateItemDetails from './hooks/generateItemDetails'
import PageTypeIdentifier from '../../../../../../helpers/PageTypeIdentifier'
import DetailsWmo from './DetailsWmo'

const Details = props => {
  const { data, index, trackSelectItem } = props
  const { isDesktop } = useResponsiveWrapperContext()
  const brand = formatBrand(data?.product?.brand?.name)

  const onClick = useCallback(() => {
    trackSelectItem()
    PageTypeIdentifier.pdp()
  }, [trackSelectItem])

  const {
    title,
    sku,
    productUrl,
    price,
    productNotes,
  } = generateItemDetails(data)

  return (
    <DetailsWmo
      data={data}
      brand={brand}
      productUrl={productUrl}
      onClick={onClick}
      title={title}
      sku={sku}
      price={price}
      index={index}
      isDesktop={isDesktop}
      productNotes={productNotes}
    />
  )
}

export default Details
